import { css } from 'styled-components';

export type LimitLinesProps = {
    lines?: number | undefined;
};

export const LimitLines = css<LimitLinesProps>`
    ${(props) =>
        props.lines &&
        `
        display: -webkit-box;
        -webkit-line-clamp: ${props.lines};
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    `}
`;
